import React from 'react';
import ModalStore, { openModal } from 'lib/stores/modalStore';
import CardEditFieldBtn from 'lib/base/Card/CardEditFieldBtn';

const ResidentEditAction = ({ resident }) => {
  const editResident = e => {
    e.preventDefault();
    ModalStore.update(state => { openModal(state, 'resident', { resident }); });
  };

  return (
    <CardEditFieldBtn
      text="Edit Resident"
      aria_label="edit resident button"
      title="edit resident button"
      onClick={editResident}
      data_testid="editResidentButton"
    />
  );
};

export default ResidentEditAction;
